export default "__VITE_ASSET__C7n4XRrx__"